<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerOutletTypes">
        <template #header>
          <ProSpaceAction
            v-if="checkEditAccess(outletType)"
            :text="$t('editItemTxt')"
            @click="editPanel"
          />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { OutletTypeService } from "../../../services/OutletTypeService";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "OutletTypePanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    filterAccessDots: {
      type: Function,
    },
    checkEditAccess: {
      type: Function,
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      outletType: null,
      outletTypeService: new OutletTypeService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerOutletTypes() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.outletType) {
        return {
          title: this.outletType.value,
          id: this.ids[0],
          status: this.getStatus(this.outletType.status),
          options: this.getAccessDots(this.options),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.outletType) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.outletType.code,
            },
          ],
          [
            {
              title: this.$t("outletTypeValue"),
              text: this.outletType.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.outletType) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.outletType.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.outletType.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text:
                this.getFormatDateTime(this.outletType.createdAt) +
                " " +
                getAMorPM(this.outletType.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text:
                this.getFormatDateTime(this.outletType.lastUpdated) +
                " " +
                getAMorPM(this.outletType.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    getAccessDots(options) {
      return this.filterAccessDots
        ? this.filterAccessDots(options, this.outletType)
        : options;
    },
    update() {
      this.hasError = false;
      try {
        this.getOutletType();
      } catch (e) {
        this.hasError = true;
      }
    },
    getOutletType() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.outletTypeService.get(this.ids[0]).then((res) => {
          this.outletType = res.data;
          this.loading = false;
        });
      }
      this.outletType = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.outletType);
    },
    deletePanel() {
      this.$emit("delete", this.outletType);
    },
    showHistoryPanel() {
      this.$emit("history", this.outletType);
    },
  },
};
</script>

<style scoped></style>
